var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import { TableHeader } from './TableHeader';
import * as PropTypes from 'prop-types';
import TableRow from './TableRow';
import ExpandableRow from './ExpandableRow';
import { ColGroup } from './ColGroup';
var BaseTable = /** @class */ (function (_super) {
    __extends(BaseTable, _super);
    function BaseTable(props) {
        var _this = _super.call(this, props) || this;
        _this.renderRows = function (renderData, indent, ancestorKeys) {
            if (ancestorKeys === void 0) { ancestorKeys = []; }
            var rows = [];
            var table = _this.context.table;
            var columnManager = table.columnManager;
            var rowClassName = table.props.rowClassName;
            var _a = _this.props, fixed = _a.fixed, getRowKey = _a.getRowKey, expander = _a.expander;
            var _loop_1 = function (i) {
                var record = renderData[i];
                var key = getRowKey(record, i);
                var className = typeof rowClassName === 'string' ? rowClassName : rowClassName(record, i);
                var leafColumns;
                if (fixed === 'left') {
                    leafColumns = columnManager.leftLeafColumns();
                }
                else if (fixed === 'right') {
                    leafColumns = columnManager.rightLeafColumns();
                }
                else {
                    leafColumns = _this.getColumns(columnManager.leafColumns());
                }
                var row = (React.createElement(ExpandableRow, __assign({}, expander.props, { record: record, key: key, rowKey: key, onExpandedChange: expander.handleExpandChange, fixed: fixed }), function (expandableRow) { return (React.createElement(TableRow, __assign({ record: record, className: className, ancestorKeys: ancestorKeys, columns: leafColumns, rowKey: key, index: i, fixed: fixed }, expandableRow))); }));
                rows.push(row);
                // 渲染展开行
                expander.renderRows(_this.renderRows, rows, record, i, indent, fixed, key, ancestorKeys);
            };
            for (var i = 0; i < renderData.length; i += 1) {
                _loop_1(i);
            }
            return rows;
        };
        return _this;
    }
    BaseTable.prototype.getColumns = function (cols) {
        var _a = this.props.columns, columns = _a === void 0 ? [] : _a;
        return (cols || columns).map(function (column) { return (__assign({}, column)); });
    };
    BaseTable.prototype.render = function () {
        var _a = this.props, columns = _a.columns, data = _a.data, hasHead = _a.hasHead, hasBody = _a.hasBody, fixed = _a.fixed, expander = _a.expander;
        var table = this.context.table;
        var scroll = table.props.scroll;
        var tableStyle = {};
        if (!fixed && scroll.x) {
            tableStyle.width = scroll.x;
        }
        return (React.createElement("table", { style: tableStyle },
            React.createElement(ColGroup, { columns: columns, fixed: fixed }),
            hasHead && React.createElement(TableHeader, { columns: columns, expander: expander, fixed: fixed }),
            hasBody && React.createElement("tbody", null, this.renderRows(data, 0))));
    };
    BaseTable.contextTypes = {
        table: PropTypes.any,
    };
    return BaseTable;
}(Component));
export { BaseTable };
